module.exports = __webpack_public_path__ + "static/media/feedback.c1e6d603.svg";